import SpotIncentive from "@/react/components/editors/incentive/spotIncentive/SpotIncentive.tsx";
import SpotIncentivePreview from "@/react/components/editors/incentive/spotIncentive/SpotIncentivePreview.tsx";

/**
 * Spot Incentive Editor Component
 * @param {Object} props
 * @param {Object} props.record - Editor record containing spotIncentive, selectedTask, initialFileId, and initialFileData
 * @param {Function} props.onClose - Callback to close the editor
 * @param {Object} props.editorInstance - Editor instance reference
 */
export const SpotIncentiveEditor = ({ record: editorRecord, onClose, editorInstance }) => {
  const {
    spotIncentive: record,
    selectedTask,
    initialFileId,
    initialFileData,
    isCreatingUnreleasedRecord,
    onReviewClick,
    onFileDetailResume,
    initialName,
    initialStartDate,
    initialEndDate,
    initialResourceIds
  } = editorRecord;

  const handleClose = () => {
    onFileDetailResume?.();
    onClose();
  };

  if (!record.isPhantom) {
    return <SpotIncentivePreview data={record} editorInstance={editorInstance} onClose={handleClose} />;
  }

  return <SpotIncentive
    record={record}
    onClose={handleClose}
    editorInstance={editorInstance}
    selectedTask={selectedTask}
    initialFileId={initialFileId}
    initialFileData={initialFileData}
    isCreatingUnreleasedRecord={isCreatingUnreleasedRecord}
    onReviewClick={onReviewClick}
    initialName={initialName}
    initialStartDate={initialStartDate}
    initialEndDate={initialEndDate}
    initialResourceIds={initialResourceIds}
  />;
};
